import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { PaymentsFlowItem, PurchasesRecord } from 'src/models';
import { RootState } from 'src/store';
import { analyticsSelectors } from 'src/store/reducers/analytics';

export const usePaymentsAnalyticsState = (): RootState['analytics'] => {
  const state = useSelector<RootState, RootState['analytics']>(
    (state) => state.analytics,
  );

  useDebugValue(state);

  return state;
};

export const usePaymentsAnalytics = (companyId: string): PaymentsFlowItem[] => {
  const state = useSelector<RootState, RootState['analytics']>(
    (state) => state.analytics,
  );

  const records = analyticsSelectors.selectById(state, companyId);

  useDebugValue(records);

  return records?.payments || [];
};

export const usePurchasesAnalytics = (companyId: string): PurchasesRecord[] => {
  const state = useSelector<RootState, RootState['analytics']>(
    (state) => state.analytics,
  );

  const records = analyticsSelectors.selectById(state, companyId);

  useDebugValue(records);

  return records?.purchases || [];
};
